import { createContext, useContext } from "react";

export type ColorScheme = "modern" | "warm" | "projection";

interface ColorSchemeContextType {
  colorScheme: ColorScheme;
  setColorScheme: (scheme: ColorScheme) => void;
}

export const ColorSchemeContext = createContext<ColorSchemeContextType | undefined>(undefined);

export function useColorScheme() {
  const context = useContext(ColorSchemeContext);
  if (context === undefined) {
    throw new Error("useColorScheme must be used within a ColorSchemeProvider");
  }
  return context;
}

export const COLOR_SCHEME_STORAGE_KEY = "color-scheme";

export const colorSchemeOptions = [
  {
    id: "projection" as const,
    name: "ProjectionLab",
    description: "Data-focused finance app",
    primaryColor: "hsl(207, 90%, 54%)",
    secondaryColor: "hsl(174, 63%, 40%)",
  },
  {
    id: "modern" as const,
    name: "Modern Finance",
    description: "Professional blue/indigo palette",
    primaryColor: "hsl(230, 80%, 55%)",
    secondaryColor: "hsl(200, 90%, 50%)",
  },
  {
    id: "warm" as const,
    name: "Warm & Friendly",
    description: "Approachable orange/amber palette",
    primaryColor: "hsl(25, 95%, 53%)",
    secondaryColor: "hsl(45, 95%, 55%)",
  },
];
